export default {"src":"/_next/static/media/document.61c8ca28.svg","height":36,"width":36};